import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import HerosectionHeader from "../../Componet/Herosection/HerosectionHeader";
import "./services.css";

import { ServicesPagePricingPlans } from "../../store/Utility/Utility";


const services = [
    {
        icon: "las la-car",
        title: "Uber Vehicle Inspection",
        description: "Complete your eligible Uber vehicle inspection remotely through a guided live video call.",
    },
    {
        icon: "las la-car",
        title: "Lyft Vehicle Inspection",
        description: "Complete your eligible Lyft vehicle inspection from your phone with guidance from a live inspector.",
    },
    {
        icon: "las la-car",
        title: "Turo Vehicle Inspection",
        description: "Complete an eligible Turo vehicle inspection remotely through our live video inspection process.",
    },
    {
        icon: "las la-car",
        title: "Pre-Purchase Inspection",
        description: "Buying a used vehicle? Get a comprehensive on-site pre-purchase inspection through Inspectiver.",
    },
    {
        icon: "las la-tools",
        title: "Need a Different Inspection?",
        description: "Need a vehicle inspection for another platform or purpose? Contact us to see if we can help.",
    },
];

const Services = () => {

    return (<>
        <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Our Services"} />
        <section className="services-section py-5">
            <Container>
                <div className="text-center mb-5">
                    <h2 className="services-title mt-2">
                        Vehicle Inspection Services
                    </h2>

                    <p className="services-description mx-auto">
                        Online vehicle inspections for rideshare and car-sharing platforms, plus comprehensive on-site pre-purchase inspections.
                    </p>
                </div>

                <Row className="g-4 justify-content-center">
                    {services.map((service) => (
                        <Col md={6} lg={4} key={service.title}>
                            <Card className="service-card h-100 border-0 text-center">
                                <Card.Body className="p-4 p-xl-5">
                                    <div className="service-icon mb-4 mx-auto">
                                        <i className={service.icon}></i>
                                    </div>

                                    <h4 className="service-card-title">
                                        {service.title}
                                    </h4>

                                    <p className="service-card-text mb-4">
                                        {service.description}
                                    </p>

                                    <Button
                                        variant="link"
                                        className="service-link p-1"
                                    >
                                        Learn More
                                        <i className="las la-arrow-right ms-2"></i>
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
            <div className="container pt-10 pb-5 text-center">
                <h2 className="fw-bold text-dark text-center">
                    Book Your Inspection
                </h2>
                <p>
                    Choose your inspection service and get started online.
                </p>
                <Link className="btn btn-dark mt-2" aria-label="Order a pre-purchase car inspection" to="/quotation">Book Inspection</Link>
            </div>
        </section>
    </>)
}

export default Services;